<template>
  <keep-alive include="GuideImgList">
    <router-view ></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "GuideImg",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
